import * as React from "react";
import { IconProps } from "./IconProps";

export const IconArchive = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.33333 2.00004C3.33333 1.63185 3.63181 1.33337 4 1.33337H7C7.17681 1.33337 7.34638 1.40361 7.4714 1.52864L8.60948 2.66671H12C12.3682 2.66671 12.6667 2.96518 12.6667 3.33337V5.33337H13.3333C13.7015 5.33337 14 5.63185 14 6.00004V13.3334C14 13.7016 13.7015 14 13.3333 14H2.66667C2.29848 14 2 13.7016 2 13.3334V6.00004C2 5.63185 2.29848 5.33337 2.66667 5.33337H3.33333V2.00004ZM4.66667 5.33337H11.3333V4.00004H8.33333C8.15652 4.00004 7.98695 3.9298 7.86193 3.80478L6.72386 2.66671H4.66667V5.33337ZM3.33333 6.66671V12.6667H12.6667V6.66671H3.33333ZM4.66667 8.66671C4.66667 8.29852 4.96514 8.00004 5.33333 8.00004H8C8.36819 8.00004 8.66667 8.29852 8.66667 8.66671C8.66667 9.0349 8.36819 9.33337 8 9.33337H5.33333C4.96514 9.33337 4.66667 9.0349 4.66667 8.66671Z"
          fill={color}
        />
      </svg>
    );
  },
);
